<template>
	<div class="admin-main">
		<div class="admin-top flex-rcc">
			主体材料
		</div>
		<van-form validate-first @submit="onSubmit" class="form-box">
			<div class="field-box">
				<van-field name="radio" label="主体类型：">
					<template #input>
						<van-radio-group v-model="radio" direction="horizontal">
							<van-radio name="1">个体工商户</van-radio>
							<van-radio name="2">公司</van-radio>
						</van-radio-group>
					</template>
				</van-field>
				<div class="remind">个体户：营业执照上的主体类型一般为个体户、个体工商户、个体经营。公司：营业执照上的主体类型一般为有限公司、有限责任公司。</div>
			</div>
			<div class="field-box">
				<van-field name="uploader" label="营业执照：">
					<template #input>
						<van-uploader v-model="uploader" :max-count="1"></van-uploader>
					</template>
				</van-field>
			</div>
			<div class="field-box">
				<van-field v-model="registration" registration="card" label="注册号/统一社会信用代码：" placeholder="请输入营业执照上的营业执照注册号" :rules="[{ required: true, message: '请输入营业执照上的营业执照注册号' }]"></van-field>
				<div class="remind">注册号格式须为15位数字或18位数字或者大写字母</div>
			</div>
			<div class="field-box">
				<van-field v-model="services" name="services" label="商户名称：" placeholder="请填写营业执照上的商户名称" :rules="[{ required: true, message: '请输入联系手机号' }]"></van-field>
				<div class="remind">1、个体户，不能以“公司”结尾。<br>
					2、个体户，若营业执照上商户名称为“空“或“无”时，填写"个体户+经营者姓名"，如“个体户张三”。</div>
			</div>
			<div class="field-box">
				<van-field v-model="name" name="name" label="法人/个体户经营者姓名：" placeholder="请填写营业执照的经营者/法定代表人姓名" :rules="[{ required: true, message: '请填写营业执照的经营者/法定代表人姓名' }]"></van-field>
			</div>
			<div class="bottom-bar-placeholder"></div>
			<div class="admin-bottom-bar">
				<van-button native-type="submit" class="button-default" :class="isApp === 'isWeixin' ? 'wx-button-primary' : 'zfb-button-primary'" >
					下一步
				</van-button>
			</div>
		</van-form>
	</div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: "index",
		data () {
      return{
        radiod: 0,
        uploader: [{ url: 'https://img.yzcdn.cn/vant/leaf.jpg' }],
        services: '',
        registration: '',
        name: '',
			}
		},
    computed: {
      ...mapState(['isApp', 'openId'])
    },
    created () {
    },
    methods: {
			next () {},
      onSubmit(values) {
        console.log('submit', values)
      }
    }
  };
</script>

<style scoped lang="stylus">
	.van-cell
		padding 5px 2px !important
		&:after
			border none !important
			border-bottom 0 !important
</style>
